<i18n>
{
  "en": {
    "title": "Cookie Kingdom configuration page",
    "onlySupportEmailLogin": "XRobotmon only support login Cookie Kingdom via DevPlay account",
    "first_time": "First time? Please refer:",
    "cookie_tutorial": "Cookie Kingdom tutorial",
    "cookie_tutorial_link": "https://cookierunkingdom.app/en/xrobotmon-tutorial",
    "still_have_not_bind_with_email": "Please check Settings > Info > My DevPlay and check if there is 'E-mail verification completed'",
    "show_advanced_config": "Show advanced config",
    "hide_advanced_config": "Hide advanced config",
    "recommend_keeping_default": "Please verify the DevPlay ID/Password is correct and can login to the game (via live streaming). You can always come back and change the advance config to better manage your kingdom.",
    "current_is": "currently is",
    "is_lower_than": "is lower than suggested minimum value:",
    "is_higher_than": "is higher than suggested maximum value:",
    "account_and_password_are_must": "DevPlay account(email) and password are required!",
    "invalid_email": "Invalid e-mail.",
    "save": "Save",
    "cancel": "Cancel",
    "reset": "Reset",
    "yes": "Yes",
    "no": "No",
    "account": "Account & Password",
    "production": "Production",
    "wishingTree": "Wishing Tree",
    "hotAirBallon": "Hot Air Ballon",
    "trainStation": "Train Station",
    "pvp": "PVP",
    "guild": "Guild",
    "gnomeLab": "Gnome Lab",
    "tradeHabor": "Trade Habor",
    "others": "Others",
    "hidden": "Hidden - Following itmes can only be seen by test account",
    "required": "required",
    "language": "en",
    "need_set_password": "Please make sure the password is set",
    "account_not_exist": "This email is not a valid DevPlay account, please collect the right email as shown in the image above"
  },
  "zhHant": {
    "title": "薑餅人王國 設定頁面",
    "onlySupportEmailLogin": "XRobotmon 目前只支援使用 DevPlay 帳號登入薑餅人王國唷",
    "first_time": "第一次使用嗎？請參考：",
    "cookie_tutorial": "薑餅人王國簡易使用教學",
    "cookie_tutorial_link": "https://cookierunkingdom.app/zh/xrobotmon-tutorial",
    "show_advanced_config": "顯示進階設定",
    "hide_advanced_config": "隱藏進階設定",
    "recommend_keeping_default": "建議先確認帳號密碼無誤可以正常啟動後，再根據自身需求變更進階設定內的數值",
    "current_is": "現在是",
    "is_lower_than": "小於建議的最小值：",
    "is_higher_than": "大於建議的最大值：",
    "account_and_password_are_must": "請輸入 DevPlay 帳號密碼",
    "invalid_email": "無效的email",
    "save": "存檔",
    "cancel": "不存檔退出",
    "reset": "重置",
    "yes": "是",
    "no": "否",
    "account": "帳號與密碼",
    "production": "生產",
    "wishingTree": "許願樹",
    "hotAirBallon": "熱氣球",
    "trainStation": "熊熊果凍列車",
    "pvp": "PVP",
    "guild": "公會",
    "gnomeLab": "地精實驗室",
    "tradeHabor": "海濱貿易船",
    "others": "其他",
    "hidden": "隱藏設定 - 以下項目只有測試帳號看得到",
    "required": "必須",
    "language": "tw",
    "need_set_password": "請確認已經設定好密碼",
    "account_not_exist": "DevPlay email 不存在，請輸入上圖範例所示的 email"
  },
  "ja": {
    "title": "クッキーラン：キングダム 設定ページ",
    "onlySupportEmailLogin": "XRobotmon 現在サポートしているのは DevPlay ",
    "first_time": "詳細な使い方はこちらからどうぞ：",
    "cookie_tutorial": "クッキーランキングダム使い方",
    "cookie_tutorial_link": "https://cookierunkingdom.app/ja/xrobotmon-tutorial",
    "show_advanced_config": "詳細設定を開く",
    "hide_advanced_config": "詳細設定を閉じる",
    "recommend_keeping_default": "正しい登録情報（メールアドレス、パスワード）を確認すると、詳細設定はよくご理解の上変更ください。",
    "current_is": "今は",
    "is_lower_than": "推奨される最小値より低い：",
    "is_higher_than": "推奨される最大値より高い：",
    "account_and_password_are_must": "DevPlayのアカウントとパスワードをご入力ください。",
    "invalid_email": "無効なメール",
    "save": "セーブ",
    "cancel": "キャンセル",
    "reset": "リセット",
    "yes": "はい",
    "no": "いいえ",
    "account": "アカウントとパスワード",
    "production": "生産",
    "wishingTree": "願い樹",
    "hotAirBallon": "くまゼリー気球",
    "trainStation": "ゼリー列車",
    "pvp": "アリーナの対戦",
    "guild": "ギルド",
    "gnomeLab": "ノーム研究所",
    "tradeHabor": "海上貿易センター",
    "others": "他の",
    "hidden": "隱藏設定 - 以下項目只有測試帳號看得到",
    "required": "必須",
    "language": "ja",
    "need_set_password": "パスワードが設定されていることを確認してください",
    "account_not_exist": "ご入力したメールアドレスは無効です。正しいメールアドレスは上記の図例のようです。"
  },
  "ko": {
    "title": "쿠키런: 킹덤 설정 페이지입니다.",
    "onlySupportEmailLogin": "XRobotmon은 DevPlay 계정으로 쿠키런: 킹덤에 접속하는 방식을 지원하고 있습니다.",
    "first_time": "처음 이용하신다면 여기를 눌러 참고하세요",
    "cookie_tutorial": "쿠키런: 킹덤 매크로 설정을 가르쳐드립니다.",
    "cookie_tutorial_link": "https://cookierunkingdom.app/ko/xrobotmon-tutorial",
    "show_advanced_config": "매크로 단계별 설정을 표시합니다.",
    "hide_advanced_config": "매크로 단계별 설정을 숨깁니다.",
    "recommend_keeping_default": "기본적으로 최적화된 수치로 설정되어 있어 필요에 따라 수정하거나, 그대로 사용하셔도 좋습니다.",
    "current_is": "현재 설정값",
    "is_lower_than": "최소로 설정 가능한 값보다 낮습니다 : ",
    "is_higher_than": "최대로 설정 가능한 값보다 높습니다 : ",
    "account_and_password_are_must": "DevPlay 계정의 비밀번호를 확인하세요.",
    "invalid_email": "잘못된 이메일입니다",
    "save": "저장",
    "cancel": "취소",
    "reset": "초기화",
    "yes": "네",
    "no": "아니요",
    "account": "계정 및 비밀번호",
    "production": "생산",
    "wishingTree": "소원나무",
    "hotAirBallon": "곰젤리 열기구",
    "trainStation": "곰젤리 열차",
    "pvp": "킹덤 아레나",
    "guild": "길드",
    "gnomeLab": "설탕노움 연구소",
    "tradeHabor": "후르츠칸 해상무역센터",
    "others": "기타",
    "hidden": "숨겨진 설정 항목 - 아래 항목은 테스트 계정만 볼 수 있습니다.",
    "required": "필요합니다",
    "language": "ko",
    "need_set_password": "DevPlay 계정과 비밀번호가 설정되어 있는지 확인하세요.",
    "account_not_exist": "존재하지 않는 DevPlay 이메일입니다. 위 그림의 예시와 같은 이메일 형식을 입력해주세요."
  }
}
</i18n>

<template>
  <div>
    <div v-show="!isLicenseFound">OOPS! This license cannot be found!</div>
    <v-card flat v-show="isLicenseFound">
      <v-card-title class="headline">{{ $t('title') }}</v-card-title>
      <v-card-text>
        <v-alert :value="true" type="warning" outline>
          {{ $t('onlySupportEmailLogin') }}
          <v-divider class="my-2 warning" style="opacity: 0.22"></v-divider>
          {{ $t('first_time') }}
          <a :href="$t('cookie_tutorial_link')" target="_blank" class="warning--text font-weight-medium">{{
            $t('cookie_tutorial')
            }}</a>
        </v-alert>
        <v-alert :value="true" type="success" class="title">
          {{ $t('need_set_password') }}
        </v-alert>
      </v-card-text>
      <v-card-text>
        <v-flex v-show="showAdvancedConfig || item.basic" xs12 sm12 md12 v-for="(item, key) in localTaskConfig"
          :key="key">
          <div v-if="item.divider !== undefined && item.divider !== '' && (!item.hidden || license.type === 'test')"
            class="mt-2 font-weight-bold font-italic">
            {{ $t(item.divider) }}
          </div>
          <v-divider class="mb-2 mt-0"
            v-if="item.divider !== undefined && item.divider !== '' && (!item.hidden || license.type === 'test')"></v-divider>

          <v-layout v-if="item.supportImages && item.supportImages[$i18n.locale]" row wrap>
            <v-flex xs12 sm6 md4 v-for="(image, index) in item.supportImages[$i18n.locale]" :key="index">
              <v-img :src="require(`@/assets/cookieKingdom/${image}`)"></v-img>
            </v-flex>
          </v-layout>

          <v-switch v-if="item.type === 'boolean'" v-model="item.value" v-show="!item.hidden || license.type === 'test'"
            :label="`${item.title[$i18n.locale]}: ${item.value ? $i18n.t('yes') : $i18n.t('no')}`">
            <template v-slot:prepend v-if="item.help">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                </template>
                {{ item.help[$i18n.locale] }}
              </v-tooltip>
            </template>
          </v-switch>

          <v-text-field v-else-if="item.type === 'string' || item.type === 'number' || item.type === 'password'"
            v-model="item.value" v-show="!item.hidden || license.type === 'test'"
            :type="item.type !== undefined ? item.type : 'text'" :rules="license !== undefined && !isEmpty(license.taskConfig) && license.taskConfig[key] === item.value
                ? []
                : item.rules
              " :error="getErrorMessage(item) !== ''" :error-messages="getErrorMessage(item)" :validate-on-blur="true"
            :label="`${item.title[$i18n.locale]}${license !== undefined && !isEmpty(license.taskConfig) && item.type !== 'password'
                ? ', ' + $i18n.t('current_is') + ' ' + license.taskConfig[key]
                : ''
              }`">
            <template v-slot:append-outer v-if="item.help">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                </template>
                {{ item.help[$i18n.locale] }}
              </v-tooltip>
            </template>
          </v-text-field>

          <v-select v-if="item.type === 'list'" :items="optionsList(item)"
            :label="`${item.title[$i18n.locale]}: ${item.options[item.value][$i18n.locale]}`" v-model="item.value">
            {{ item.value }}
            <template v-slot:append-outer v-if="item.help">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                </template>
                {{ item.help[$i18n.locale] }}
              </v-tooltip>
            </template>
          </v-select>
        </v-flex>

        <v-alert v-show="!showAdvancedConfig" :value="true" type="info" outline>{{
          $t('recommend_keeping_default')
          }}</v-alert>

        <v-btn @click="showAdvancedConfig = !showAdvancedConfig" block>{{
          showAdvancedConfig ? $t('hide_advanced_config') : $t('show_advanced_config')
          }}</v-btn>
      </v-card-text>
      <v-card-actions>
        <v-btn color="grey" @click="reset" outline>{{ $t('reset') }}</v-btn>
        <v-spacer />
        <v-btn color="red" outline @click="back">{{ $t('cancel') }}</v-btn>
        <v-btn color="green" @click="save" :disabled="isLoading" :loading="isLoading">{{ $t('save') }}</v-btn>
      </v-card-actions>
      <v-card-title></v-card-title>
    </v-card>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';

export default {
  name: 'configTsum',
  props: {
    license: {
      type: Object,
      required: true,
    },
  },
  data() {
    const validatedRules = {
      required: value => !!value || this.$i18n.t('required'),
      email: value => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || this.$i18n.t('invalid_email');
      },
    };
    const defaultConfig = {
      account: {
        value: '',
        error: '',
        rules: [validatedRules.email],
        basic: true,
        type: 'string',
        title: {
          en: 'DevPlay Account (should be an email address)',
          zhHant: 'DevPlay帳號 (請填email)',
          ja: 'DevPlay アカウント (メールアドレスを入力してください)',
          ko: 'DevPlay 계정의 ID(이메일)을 입력하세요. 현재 : ',
        },
        help: {
          en: 'the DevPlay email address (DevPlay Account will be encrypted when save, thus seems like random numbers)',
          zhHant: 'DevPlay 登入用email (DevPlay帳號將會經過加密處理，亂碼屬正常現象)',
          ja: 'こちらはDevPlay IDではなく、メールを入力してください (アカウントは暗号化されますので、文字化けしたコードは正常です)',
          ko: '암호화되어 보이는 현상은 정상입니다',
        },
        divider: 'account',
        supportImages: {
          en: ['cken1.jpeg', 'cken2.jpeg'],
          zhHant: ['cktw1.jpeg', 'cktw2.jpeg'],
          ja: ['ckja1.jpeg', 'ckja2.jpeg'],
          ko: ['ckko1.jpeg', 'ckko2.jpeg'],
        },
      },
      password: {
        value: '',
        rules: [validatedRules.required],
        basic: true,
        type: 'password',
        title: {
          en: 'DevPlay Password',
          zhHant: 'DevPlay 密碼',
          ja: 'DevPlay パスワード',
          ko: 'DevPlay 비밀번호를 입력하세요',
        },
        help: {
          en: 'DevPlay Password will be encrypted. And seems like random numbers',
          zhHant: 'DevPlay帳號將會經過加密處理，亂碼屬正常現象（請確認是否正確）',
          ja: 'DevPlayアカウントは暗号化されますので、文字化けしたコードは正常です',
          ko: '암호화된 난코드는 정상적인 현상입니다',
        },
      },
      materialsTarget: {
        value: 800,
        hidden: false,
        suggestedMin: 200,
        type: 'number',
        title: {
          en: 'Material stock target',
          zhHant: '材料生產目標',
          ja: '材料の保有数／個',
          ko: '재료 생산 목표입니다.',
        },
        help: {
          en: 'The target stock of materials (made by gold coins)',
          zhHant: '材料（以金幣製作）的庫存目標',
          ja: '基本材料（コインでの）倉庫での生産アイテム数',
          ko: '코인으로 제작하는 재료의 재고 목표입니다',
        },
        divider: 'production',
        supportImages: {
          en: ['cken3.jpeg'],
          zhHant: ['cktw3.jpeg'],
          ja: ['ckja3.jpeg'],
          ko: ['ckko3.jpeg'],
        },
      },
      goodsTarget: {
        value: 120,
        hidden: false,
        suggestedMax: 300,
        suggestedMin: 10,
        type: 'number',
        title: {
          en: 'Goods stock target',
          zhHant: '產品庫存目標',
          ja: '生産品の保有数／個',
          ko: '생산품 생산 목표입니다.',
        },
        help: {
          en: 'The target stocks of goods (made by materials)',
          zhHant: '加工品（以材料製成）的庫存目標',
          ja: '組合せ生産アイテム（材料を組み合わせて生産)在庫あり生産アイテム数',
          ko: '재료로 제작되는 생산품의 재고 목표입니다.',
        },
      },
      productSafetyStock: {
        value: 10,
        hidden: false,
        suggestedMax: 30,
        suggestedMin: 10,
        type: 'number',
        title: {
          en: 'Safety stock of the production',
          zhHant: '生產時安全庫存',
          ja: '材料と生産品の安全保有数／個',
          ko: '생산 안전 재고',
        },
        help: {
          en: 'Skip production if material amount is under this value. ',
          zhHant: '當材料低於此數值時不會進行生產，保護火車等有物資可以送',
          ja: '生産するとき、欠品を防ぐ為に、最低限必要な在庫量を設定する',
          ko: '생산품을 만들때 필요한 재료가 이 수치보다 낮을때는 해당 생산품을 만들지 않습니다.',
        },
      },
      autoMagicLabTarget: {
        value: 'upgrade',
        hidden: false,
        type: 'list',
        basic: false,
        options: {
          resonant: {
            en: 'make resonant ingredients',
            zhHant: '生產魔法糖',
            ja: '専用材料を制作する',
            ko: '전용 재료 생산하기',
          },
          upgrade: {
            en: 'make upgrade ingredients',
            zhHant: '生產升級物資',
            ja: '成長材料を制作する',
            ko: '성장 재료 생산하기',
          },
          disabled: {
            en: 'disable auto handle magic lab',
            zhHant: '不自動生產',
            ja: '自動制作しない',
            ko: '자동 생산하지 않기',
          },
        },
        title: {
          en: 'Magic laboratory target',
          zhHant: '魔法實驗室生產目標',
          ja: '魔法工房制作',
          ko: '마법공방의생산 목표',
        },
        help: {
          en: 'Choose what to produce in magic lab',
          zhHant: '魔法實驗室要生產的產品類別',
          ja: '専用材料又は成長材料を制作する',
          ko: '성장 재료를 생산하기',
        },
      },
      magicLabProductIndex: {
        value: 0,
        hidden: false,
        type: 'number',
        title: {
          en: 'Specify which item to produce in the magic lab (will be ignored if choose to skip magic lab production)',
          zhHant: '指定魔法研究室要生產第幾個項目(如勾選略過魔法研究室選項，則本設定不會生效)',
          ja: '魔法工房で何目の生産品を生産する（例：数字1はエスプレッソ）自動生産されないを設定した場合、こちら無効になる',
          ko: '마법공방에서 몇번째 순서의 생산품을 만들것인지 지정합니다. (마법공방 옵션을 체크하지 않은 경우 이 설정옵션은 적용되지 않습니다.)',
        },
        help: {
          en: 'The magic lab will keep producing the selected item regardless the stock. If set to 0, will be treated as normal production building and apply production target like others',
          zhHant: '不管存量如何，都會不斷生產指定的項目，如設為零則會視為一般生產建築，平均的生產。',
          ja: '0を設定する場合、在庫量を問わず、魔法工房の生産品をランダムに生産する',
          ko: '재고량에 상관없이 지정된 순서의 생산품을 지속적으로 생산합니다 (0으로 설정시 일반 생산 건물과 마찬가지로 모든 품목이 균형있게 생산합니다.)',
        },
      },
      alwaysFulfillWishes: {
        value: false,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Fulfill wishes regardless if all the wishing tree daily rewards are claimed',
          zhHant: '不論是否已經取得所有許願禮物，還是送許願樹',
          ja: '願い樹のデイリー報酬全部GETでも自動渡す：（はい/いいえ）？',
          ko: '일일 보상 3회를 모두 받은 후에도 소원나무를 계속 해서 전달합니다.',
        },
        help: {
          en: 'Very useful when you need to farm lots of gold',
          zhHant: '衝金幣專用',
          ja: 'コインの為',
          ko: '코인을 벌기 위한 경우에만 사용하세요.',
        },
        divider: 'wishingTree',
        supportImages: {
          en: ['cken4.jpeg'],
          zhHant: ['cktw4.jpeg'],
          ja: ['ckja4.jpeg'],
          ko: ['ckko4.jpeg'],
        },
      },
      wishingTreeRefreshGoldenWishes: {
        value: true,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto refresh golden wishes',
          zhHant: '是否自動重置金色的願望',
          ja: '金色の願いをリセットする(はい／いいえ)',
          ko: '황금소원은 전달하지 않고, 자동으로 새로운 소원으로 갱신합니다.',
        },
        help: {
          en: 'Disable this during Golden Age of Trade to trade all the high-end products',
          zhHant: '平常建議開啟，以便在大貿易時代關閉大量送出金色的願望',
          ja: '大交易時代の期間に金色の願いを渡して、高得点を獲得する。それ以外に渡さないほうが良い。リセットすると、金色の願いを渡さない。',
          ko: '대무역 이벤트를 대비하기 위해서 평소에는 기능을 켜두는것을 추천합니다.',
        },
      },
      autoFulfillWishesIntervalInMins: {
        value: 10,
        hidden: false,
        suggestedMax: 300,
        suggestedMin: 10,
        type: 'number',
        title: {
          en: 'Auto fulfill wishing tree interval (set to 0 to skip this task)',
          zhHant: '每隔幾分鐘檢查許願樹 (設為0則不會進行此工作)',
          ja: '願い樹の自動渡す/分間（金色を渡さない)',
          ko: '몇 분 간격으로 소원나무에서 자동으로 전달할까요? (0으로 설정하면 진행하지 않습니다.)',
        },
        help: {
          en: 'Fulfill non-golden wishes when there are enough stock',
          zhHant: '自動送出庫存足夠且不是金色的許願',
          ja: '「0」を設定したら、動作されません。',
          ko: '황금소원은 전달하지 않고, 자동으로 새로운 소원으로 갱신합니다.',
        },
      },
      wishingTreeSafetyStock: {
        value: 40,
        hidden: false,
        suggestedMin: 10,
        type: 'number',
        title: {
          en: 'Safety stock when fulfilling wishes in the tree',
          zhHant: '許願樹安全庫存',
          ja: '願い樹渡す材料と生産品の保有数/個',
          ko: '소원나무 안전 재고량 입니다.',
        },
        help: {
          en: 'Auto refresh the wish when the required item stock is below this value',
          zhHant: '當願望的需求庫存低於此數值時自動重新取得願望',
          ja: '何個以上で渡せる/納品がない場合、自動更新される',
          ko: '이 수치보다 낮은 갯수의 재고는 자동으로 새로운 소원으로 갱신합니다.',
        },
      },
      // autoHandleEventWishingTreeAmounts: {
      //   value: 0,
      //   hidden: false,
      //   suggestedMin: 0,
      //   type: "number",
      //   title: {
      //     en: "Safety stock when fulfilling wishes in the tree",
      //     zhHant: "限時活動，迪士尼許願樹每十分鐘送幾輪",
      //     ja: "願い樹渡す材料と生産品の保有数/個",
      //     ko: "소원나무 안전재고입니다"
      //   },
      //   help: {
      //     en:
      //       "Auto refresh the wish when the required item stock is below this value",
      //     zhHant: "當願望的需求庫存低於此數值時自動重新取得願望",
      //     ja: "何個以上で渡せる/納品がない場合、自動更新される",
      //     ko:
      //       "소망의 수요 재고가 이 수치보다 낮을 때 자동으로 소망을 다시 얻습니다"
      //   }
      // },
      isHotAirBallonGotoEp4: {
        value: false,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Force target the hot air ballon to ep4',
          zhHant: '指定將熱氣球送到第四章',
          ja: 'くまゼリー気球のEp4.を探検する',
          ko: '곰젤리 열기구를 에피소드4로 고정시켜 탐사를 보냅니다.',
        },
        help: {
          en: 'Enable this when event requires sending hot air ballon count',
          zhHant: '如果有活動要衝熱氣球發送次數，可以開啟此選項',
          ja: 'イベントの為に探検に出す',
          ko: '곰젤리 열기구를 반복해서 보내야 하는 이벤트가 있을때 이 기능을 활용하세요.',
        },
        divider: 'hotAirBallon',
      },
      autoSendHotAirBallonIntervalInMins: {
        value: 40,
        hidden: false,
        suggestedMax: 300,
        suggestedMin: 20,
        type: 'number',
        title: {
          en: 'Auto send hot air ballon interval interval (set to 0 to skip this task)',
          zhHant: '每隔幾分鐘自動送出熱氣球 (設為0則不會進行此工作)',
          ja: 'くまゼリー気球自動探検/分間',
          ko: '몇 분 간격으로 곰젤리 열기구를 보낼까요? (0으로 설정하면 진행하지 않습니다.)',
        },
        help: {
          en: 'Ballon will be sent to the highest map available',
          zhHant: '會自動尋找最高級的地圖送熱氣球',
          ja: '「0」を設定したら、動作されません。',
          ko: '자동으로 가장 높은 지역으로 열기구를 보냅니다.',
        },
      },
      autoLabResearch: {
        value: false,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Check gnome lab every 20 mins for possible research targets',
          zhHant: '每20分鐘檢查地精研究室',
          ja: '20分毎にノーム研究所をチェックする：はい／いいえ',
          ko: '20분마다, 설탕노움 연구소에서 연구가능한 연구가 있는지 확인합니다.',
        },
        help: {
          en: 'Check all the kingdom-related research targets, then cookie-related ones if both are enabled.',
          zhHant: '如果王國＆餅乾研究都有開，王國相關的都研究完才會去升級餅乾相關的',
          ja: '20分毎に王国の研究やクッキーの研究をチェックすると、自動研究できる。',
          ko: '왕국 연구를 우선으로 하며, 모든 왕국 연구가 모두 완료되면 쿠키 연구를 진행합니다.',
        },
        divider: 'gnomeLab',
      },
      autoResearchKingdom: {
        value: true,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto research Kingdom related items (tap question mark for detail)',
          zhHant: '自動研究時，會研發強化王國生產力相關內容（細項請見說明）',
          ja: '自動で王国の研究：はい／いいえ',
          ko: '자동 연구시, 왕국 연구를 우선으로 연구합니다.',
        },
        help: {
          en: 'Including: Gnome crafting/ research/ candy house production/ train speed, storage space, materials (milk & cottom) speed, smithy/bakery/flower/diner/latte/barrelInn/maison Du Cake/jewelry production speed',
          zhHant:
            '研發包含：建造加速、材料/成品全體生產加速、倉庫儲存空間、糖果屋、材料（牛奶、棉花）、鐵匠、麵包店、花店、果醬餐聽、Cafe Latte、木桶休憩所、蛋糕、珠寶、研發速度、火車速度',
          ja: '王国の研究は、ノームの建設加速、材料/生産品の生産加速、倉庫拡張、クッキーハウスの生産加速、材料(牛乳井戸、綿あめ牧場の生産加速)、鍛冶屋、パン屋、花屋、ジャムパイ食堂、カフェラテ、オーク樽休憩所、パティスリー、サロンドビジュの生産加速、研究加速、ゼリー列車の交易時間減少のこと。',
          ko: '해당 연구 : 설탕노움 연구 가속, 재료/생산품 생산 가속, 창고 재료/생산품 스택량 증가, 쿠키 하우스 생산 가속, 곰젤리 열차 교역시간 감소, 연구 가속, 곰젤리 열차 교역시간 감소',
        },
      },
      autoResearchCookies: {
        value: false,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto research Cookie related items (tap question mark for detail)',
          zhHant: '自動研究時，會研發強化餅乾戰鬥力相關內容（細項請見說明）',
          ja: '自動でクッキーの研究：はい／いいえ',
          ko: '자동 연구시, 쿠키 연구를 우선으로 연구합니다.',
        },
        help: {
          en: 'Including all the health, defense, attack of all 8 types of cookies',
          zhHant: '研發八種餅乾的所有屬性，如攻擊、血條等全部',
          ja: '自動クッキーの研究は、クッキーの攻撃力UP、体力UP、防御力UPなどすべて研究できる。',
          ko: '8가지 모든 유형의 쿠키의 공격력/체력/방어력 등 모든 것을 연구합니다.',
        },
      },
      autoLabUseAuroraMaterial: {
        value: true,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto research can use Aurora resources',
          zhHant: '自動研究時，允許研發要消耗極光材料的項目',
          ja: '自動研究するとき、レア材料を自動渡す：はい／いいえ',
          ko: '자동 연구시, 오로라 재료를 소모하는 연구를 진행합니다.',
        },
        help: {
          en: 'Will not use Aurora columns, bricks and compas for research when set to off',
          zhHant: '如果關閉，就不會消耗極光柱子、磚塊、指南針',
          ja: '閉じると、レア材料を渡さない。',
          ko: '설정을 하지 않으면, 오로라 기둥, 벽돌, 나침반이 소모되지 않습니다.',
        },
      },

      autoHandleTradeHabor: {
        value: false,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto send trade habor ship',
          zhHant: '自動上貨並送出貿易船',
          ja: '海上貿易センターの出荷するアイテムを自動渡す',
          ko: '자동으로 후르츠칸 해상무역센터에서 무역선을 보냅니다.',
        },
        help: {
          en: 'Upload the trade cargo from the left most product, will keep uploading until ship is full regardless if the score is exceed requirments.',
          zhHant: '自動從最左邊的產品開始送上船，如果分數有超過太多就會少上一件貨，試下一件貨品上到船開出為止',
          ja: '左のおすすめの品から自動出荷して、アイテムを自動選択して、船が自動出発できる。',
          ko: '추천 무역품의 왼쪽 생산품을 우선으로 배에 실어 보냅니다.',
        },
        divider: 'tradeHabor',
      },
      autoBalanceAuroraStocks: {
        value: true,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto exchange and balance Aurora items if stock is greater than 50',
          zhHant: '進入貿易所時，當極光材料超過50個時，自動用多的材料換少的',
          ja: 'レア材料は50コ未満の場合、一番多いものを少ないものと交換する。',
          ko: '오로라 재료가 50개 이상일때, 후르츠칸 앵무의 해변 교역소에서 자동으로 많은 재료와 적은 재료를 서로 교환합니다.',
        },
        help: {
          en: 'eg. Auto trade brick with column if having 52 columns and 8 bricks in stock.',
          zhHant: '例如有52個極光柱子，8個磚塊，就會自動兌換',
          ja: '例：オーロラ柱52個、オーロラレンガ8個の場合、柱をレンガと交換する。',
          ko: '예를 들어, 오로라 기둥이 52개, 벽돌이 8개 있다면, 자동으로 교환합니다.',
        },
      },
      autoBuyCaramelStuff: {
        value: false,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto purchase carmel items in seaside shop',
          zhHant: '進入貿易所時，自動跟大鳥買海邊商店的焦糖地圖＆望遠鏡',
          ja: 'レア材料で地図の欠片とキャラメルを購入する',
          ko: "후루츠칸 앵무의 해변 교역소에서 '캐러멜 망원경' 과 '지도 조각' 을 자동으로 구매합니다.",
        },
        help: {
          en: 'Purchase carmel map & spyglass only if aurora items stock is more than 100',
          zhHant: '極光材料超過一百個才會買',
          ja: 'レア材料100個以上で交換できる。',
          ko: '해당 기능은 오로라 재료가 100개 넘을때만 작동합니다.',
        },
      },
      autoBuyRadiantShardsInHabor: {
        value: false,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto purchase radiant shards in seaside shop',
          zhHant: '進入貿易所時，自動跟大鳥買海邊商店的燦爛的光之碎片',
          ja: 'レア材料できらめく光の欠片を購入する',
          ko: "후르츠칸 앵무의 해변 교역소에서 '찬란한 빛조각'을 자동으로 구매합니다.",
        },
        help: {
          en: 'Purchase radiant shards as long as there are enough aurora items',
          zhHant: '只要極光材料夠就會買',
          ja: 'レア材料が足りる場合、自動購入する',
          ko: '구매하기 위한 오로라 재료 갯수가 충족된다면 자동으로 구매합니다.',
        },
      },
      autoShopInSeasideMarket: {
        value: false,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Purchase white/blue/pruple skill powder, purity/swiftness/arcane/power crystals, milk and cotton in seaside market.',
          zhHant: '進入貿易所時，自動購買不夠的白藍紫色技能粉末、各種砂糖結晶、牛奶及棉花。',
          ja: 'ハッシーの交易所で自動に不足なパウダー、砂糖の結晶、ミルキー牛乳、綿あめ羊毛を交換する。',
          ko: "후르츠칸 앵무의 해변 교역소에서 '스킬 파우더'와 '설탕결정', '우유', '솜사탕 양털'을 자동으로 구매합니다.",
        },
        help: {
          en: "Only purchase when resources stock is more than 'Goods stock target', and object of interest stock is less than 'Material stock target'",
          zhHant: "購買時所需物資存量大於'產品庫存目標'，且購買目標存量少於'材料生產目標'才會購買'",
          ja: '交換条件：倉庫で材料保有数はXRで設定した材料保有数より多い、そして交換する材料の保有数は生産した保有数より少ない場合交換する。',
          ko: "교환에 필요한 재료의 갯수가 '재료 생산 목표'보다 많아야 합니다. 그리고 교환을 통해 획득할 품목의 현재 소지 갯수는 '생산품 생산 목표'보다 적어야 합니다.",
        },
      },
      autoBuySeaFairy: {
        value: true,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto purchase legendary cookie soulstones',
          zhHant: '進入五色貝殼商店時，自動買傳奇餅乾碎片',
          ja: '自動でギャラリーで伝説クッキーの霊魂石を購入',
          ko: "오색 조개 갤러리에서 '레전더리 등급의 쿠키 영혼석' 을 자동으로 구매합니다.",
        },
        help: {
          en: 'Purchase the sea fairy cookie if there are enough rainbow pearl',
          zhHant: '如果有足夠的彩虹貝殼，就自動買海妖精碎片',
          ja: '五色シェルの数が足りる場合、霊魂石を自動購入する。',
          ko: '구매하기 위한 오색 진주 갯수가 충족된다면 자동으로 구매합니다.',
        },
      },
      autoBuyGuildRelic: {
        value: true,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto purchase guild relics',
          zhHant: '進入五色貝殼商店時，自動買公會文物',
          ja: 'ギルドの遺物を自動購入する',
          ko: "오색 조개 갤러리에서 '길드 유물' 을 자동으로 구매합니다.",
        },
        help: {
          en: 'Purchase the guild relics if there are enough rainbow pearl',
          zhHant: '如果有足夠的彩虹貝殼，就自動買公會文物',
          ja: '五色シェルが足りる場合、自動購入する',
          ko: '구매하기 위한 오색 진주 갯수가 충족된다면 자동으로 구매합니다.',
        },
      },
      autoBuyEpicSoulEssence: {
        value: false,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto purchase Epic Sould Essence',
          zhHant: '進入五色貝殼商店時，自動買超級稀有靈魂碎片',
          ja: 'EPIC魂の欠片を自動購入',
          ko: "오색 조개 갤러리에서 '에픽 영혼의 조각' 을 자동으로 구매합니다.",
        },
        help: {
          en: 'Purchase all epic soul esssences if there are enough rainbow pearl',
          zhHant: '如果有足夠的彩虹貝殼，就自動買全部的超級稀有靈魂碎片',
          ja: '五色パールが足りない場合、交換されない。',
          ko: '구매하기 위한 오색 진주 갯수가 충족된다면 자동으로 구매합니다.',
        },
      },
      autoBuyLegendSoulEssence: {
        value: false,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto purchase Lenged Soul Essence',
          zhHant: '進入五色貝殼商店時，自動買傳奇靈魂碎片',
          ja: 'LEGENDARY 魂の欠片を自動購入',
          ko: "오색 조개 갤러리에서 '전설 영혼의 조각' 을 자동으로 구매합니다.",
        },
        help: {
          en: 'Purchase all epic soul essences if there are enough rainbow pearl',
          zhHant: '如果有足夠的彩虹貝殼，就自動買全部的傳奇靈魂碎片',
          ja: '五色パールが足りない場合、交換されない。',
          ko: '구매하기 위한 오색 진주 갯수가 충족된다면 자동으로 구매합니다.',
        },
      },
      autoCollectTrainIntervalInMins: {
        value: 40,
        hidden: false,
        suggestedMax: 300,
        suggestedMin: 20,
        type: 'number',
        title: {
          en: 'Auto receive/send trains interval (set to 0 to skip this task)',
          zhHant: '每隔幾分鐘收發火車 (設為0則不會進行此工作)',
          ja: 'ゼリー列車を自動受け取る/自動納品する/分間（数字）',
          ko: '몇 분 간격으로 곰젤리 열차를 받을까요?',
        },
        help: {
          en: 'Collect star jelly every specified minutes',
          zhHant: '極光材料永不嫌多',
          ja: '「0」を設定したら、動作されません。',
          ko: '곰젤리 열차를 자동으로 보내 오로라 재료들을 모을 수 있습니다. 오로라 재료는 많을수록 좋습니다.',
        },
        divider: 'trainStation',
      },

      autoPvPIntervalInMins: {
        value: 0,
        hidden: false,
        suggestedMax: 300,
        suggestedMin: 10,
        type: 'number',
        title: {
          en: 'Auto PvP interval interval (set to 0 to skip this task)',
          zhHant: '每隔幾分鐘自動進行 PvP 對戰 (設為0則不會進行此工作)',
          ja: '自動アリーナの対戦/分間（０は対戦しない)',
          ko: '몇 분 간격으로 킹덤 아레나를 진행할까요? (0으로 설정하면 진행하지 않습니다.)',
        },
        help: {
          en: 'Please use the next setting to config maximum power of your opponent',
          zhHant: '請搭配下一項設定對手的戰力上限',
          ja: '相手の戦闘力を設定してください',
          ko: '아래 설정 항목에서 상대의 전투력 상한을 설정해 주세요.',
        },
        divider: 'pvp',
      },
      autoPvPTargetScoreLimit: {
        value: 200000,
        hidden: false,
        type: 'number',
        title: {
          en: 'Maximum power of your oponent during PvP',
          zhHant: '自動PvP時，對手戰力小於此目標',
          ja: '自動アリーナの対戦相手の戦闘力は/（数字)以下',
          ko: '상대의 전투력 수치가 설정한 값보다 낮은 경우에만 진행합니다.',
        },
        help: {
          en: 'Please enable auto PvP for this setting',
          zhHant: '須開啟PVP才會生效',
          ja: '自動対戦機能有効にする場合できる',
          ko: '킹덤 아레나 자동 진행 기능을 켜야 작동합니다.',
        },
      },
      autoPvPPurchaseAncientCookie: {
        value: true,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto purchase PVP medal shop upper left ancient & super epic cookie soul stone when in PVP arena',
          zhHant: '進入競技場時，自動購買PVP商城左上角的上古 & 超傳奇餅乾',
          ja: 'メダルショップで自動で英雄クッキーとオデッセイクッキーの霊魂石を購入する',
          ko: '킹덤 아레나에 입장할때마다, 메달 상점에서 레전더리 등급의 쿠키 영혼석을 자동으로 구매합니다.',
        },
        help: {
          en: 'Please enable auto PvP for this setting',
          zhHant: '須開啟PVP才會生效',
          ja: '自動対戦機能有効にする場合できる',
          ko: '킹덤 아레나 자동 진행 기능을 켜야 작동합니다.',
        },
      },
      autoSuperMayhemIntervalInMins: {
        value: 0,
        hidden: false,
        suggestedMax: 300,
        suggestedMin: 10,
        type: 'number',
        title: {
          en: 'Auto Super Mayhem interval interval (set to 0 to skip this task)',
          zhHant: '每隔幾分鐘自動進行 大亂鬥 對戰 (設為0則不會進行此工作)',
          ja: '大乱闘自動戦闘をチェックする（／分毎）',
          ko: '몇 분 간격으로 대난투를 진행할까요? (0으로 설정하면 진행하지 않습니다.)',
        },
        help: {
          en: 'Please use the next setting to config maximum power of your opponent',
          zhHant: '請搭配下一項設定對手的戰力上限',
          ja: '0を設定したら、動作されない。',
          ko: '아래 설정 항목에서 상대의 전투력 상한을 설정해 주세요.',
        },
      },
      autoSuperMayhemTargetScoreLimit: {
        value: 200000,
        hidden: false,
        type: 'number',
        title: {
          en: "None of the team in your opponent's teams can exceed this value",
          zhHant: '自動大亂鬥時，對手團隊中的戰力最大值不超過此目標',
          ja: '自動大乱闘の対戦相手の戦闘力は/（数字)以下',
          ko: '가장 높은 상대 덱의 전투력 수치가 설정한 값보다 낮은 경우에만 진행합니다.',
        },
        help: {
          en: 'Please enable auto super mayhem for this setting',
          zhHant: '須開啟自動大亂鬥才會生效',
          ja: '自動対戦機能有効にする場合できる',
          ko: '대난투 자동 진행 기능을 켜야 작동합니다.',
        },
      },
      autoGuildAllianceBattle: {
        value: false,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto alliance battle during checkin guild (every 2 hours)',
          zhHant: '每兩小時自動打卡公會時，順便打守護之戰',
          ja: '2時間毎に約束のトーチをタップして、守りの戦域を自動戦闘する',
          ko: '매 두시간마다, 길드에 체크인을 하고, 수호의 성전을 진행합니다. (용기의 봉화 7일 자동구매)',
        },
        help: {
          en: 'Auto light up the Beacon of Valor for 7 days',
          zhHant: '會自動點亮七天的公會戰火炬',
          ja: '守りの戦域を開いた場合、自動で勇気のトーチ(7日)を購入する',
          ko: '수호의 성전 진행시, 용기의 봉화는 7일짜리를 자동으로 구매합니다.',
        },
        divider: 'guild',
      },
      autoGuildClaimNewLand: {
        value: true,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto deliver tools to expand lands during guild checkin',
          zhHant: '每兩小時自動打卡公會時，順便繳交開荒工具',
          ja: '2時間毎に約束のトーチをタップして、ギルド領土を自動拡張する',
          ko: '매 두시간마다, 길드에 체크인을 하고, 길드 영토를 확장시키기 위해 재료를 넣습니다.',
        },
        help: {
          en: 'Selected lands will be delivered first (if found)',
          zhHant: '如果先看到公會指定的就會繳指定的，不然就會繳普通的',
          ja: '優先拡張で投入する。又は普通な領土で投入する。',
          ko: '길드에서 지정한 확장 우선순위 영토가 있을경우 해당 영토 확장을 우선으로 합니다.',
        },
      },
      autoGuildBattleDragon: {
        value: false,
        hidden: false,
        suggestedMax: 300,
        suggestedMin: 60,
        type: 'boolean',
        title: {
          en: 'Auto battle guild dragon during guild checkin',
          zhHant: '每兩小時自動打卡公會時，順便打公會龍',
          ja: '2時間毎約束にのトーチをタップして、ギルド討伐戦を自動戦闘する',
          ko: '매 두시간마다, 길드에 체크인을 하고, 토벌전을 진행합니다.',
        },
        help: {
          en: 'Selected lands will be delivered first (if found)',
          zhHant: '每次檢查公會只會打一次公會龍，以便其他人可以打',
          ja: '毎度1回で、一日中3回完成できる。',
          ko: '다른 사람과 겹치지 않도록, 매번 토벌전 입장시마다 한번만 칩니다.',
        },
      },

      autoCollectDailyReward: {
        value: true,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto collect daily Kingdom pass reward, free gacha and free item in the shop',
          zhHant: '是否自動收通行證、免費轉蛋及商城免費禮物',
          ja: '毎日キングダムパス報酬、無料ギフト/無料パックを自動受け取る（はい/いいえ）',
          ko: "'킹덤패스 보상', '매일 무료 선물 뽑기' , '하루 한번 무료 패키지'를 자동으로 수령합니다.",
        },
        help: {
          en: 'Daily kingdom pass reward, free star jelly star and diamonds, will skip the ones need to watch ads',
          zhHant: '每日王國經驗、免費經驗糖及鑽石，需要看廣告的禮物不會收',
          ja: 'ミッションポイント、クッキーの霊魂石と様々なトッピングと無料パックが手にいる。＊CMの報酬は受け取れません。',
          ko: "매일 무료로 다이아몬드와 '경험의 별사탕'을 획득하세요. 광고를 봐야하는 선물은 받지 않습니다.",
        },
        divider: 'others',
      },
      // autoHandleTowerOfSweetChaos: {
      //   value: false,
      //   hidden: false,
      //   type: 'boolean',
      //   title: {
      //     en: 'Clear Tower of Sweet Chaos',
      //     zhHant: '自動爬蛋糕塔',
      //     ja: 'カオスの塔を自動戦闘する（はい／いいえ)',
      //     ko: '혼돈의 케이크 타워를 자동으로 진행합니다.',
      //   },
      //   help: {
      //     en: 'Auto climb the Tower of Sweet Chaos until battle lost or run out of keys',
      //     zhHant: '現在只會往上打，直到失敗或沒KEY為止',
      //     ja: '次の階を進めて、戦闘失敗したや燃える鍵が足りない場合、戦闘停止する',
      //     ko: '실패하거나, 키가 없을때 까지 자동으로 가장 높은 단계를 시도합니다.',
      //   },
      // },

      autoUpgradeCandyHouse: {
        value: false,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto levelup cookie house',
          zhHant: '自動升餅乾屋',
          ja: 'クッキーハウスが自動でレベルアップ(はい/いいえ))',
          ko: '자동으로 쿠키 하우스를 업그레이드 할까요?',
        },
        help: {
          en: 'Higher level cookie house = higher cookie level',
          zhHant: '更多小屋＝更多糖＝餅乾升級',
          ja: 'スターキャンディが多くなる',
          ko: "쿠키 하우스가 높을수록 더 많은 '경험의 별사탕' 을 획득 할 수 있습니다.",
        },
      },
      worksBeforeCollectCandy: {
        value: 40,
        hidden: false,
        suggestedMax: 300,
        suggestedMin: 20,
        type: 'number',
        title: {
          en: 'Interval between collecting star jelly (set to 0 to skip this task)',
          zhHant: '每隔多少分鐘收星星糖 (設為0則不會進行此工作)',
          ja: 'EXPキャンディを自動回収／分間',
          ko: '몇 분 간격으로 별사탕을 받을까요?',
        },
        help: {
          en: 'Collect star jelly every specified minutes',
          zhHant: '時間到了會自動收集星星糖再繼續生產',
          ja: '「0」を設定したら、動作されません。',
          ko: "시간이 되면 자동으로 '경험의 별사탕' 을 받고 계속 생산합니다.",
        },
      },

      autoBountiesTarget: {
        value: 'powder',
        hidden: false,
        type: 'list',
        basic: false,
        options: {
          powder: {
            en: 'skill powder',
            zhHant: '技能粉末',
            ja: 'スキルパウダー',
            ko: '스킬 파우더',
          },
          crystal: {
            en: 'sugar crystals',
            zhHant: '砂糖結晶',
            ja: '砂糖の結晶',
            ko: '설탕 결정',
          },
          cake: {
            en: 'chaos cake piece',
            zhHant: '蛋糕碎塊',
            ja: 'カオスケーキの欠片',
            ko: '혼돈의 케이크 파편',
          },
          disabled: {
            en: 'disable auto bounties',
            zhHant: '不自動打懸賞',
            ja: 'オートバウンティを無効にする',
            ko: '자동 현상금 비활성화',
          },
        },
        title: {
          en: 'Choose bounty target',
          zhHant: '懸賞目標',
          ja: '指名手配の材料',
          ko: '현상 수배의 재료',
        },
        help: {
          en: 'Auto clear selected bounty level',
          zhHant: '懸賞會自動打選定的關卡',
          ja: '自動で戦闘するステージを選択',
          ko: '자동으로 전투할 스테이지 선택',
        },
      },
      // TrialGroundTarget: 'disabled', '1', '2', '3'
      autoTrialGroundsTarget: {
        value: 'disabled',
        hidden: false,
        type: 'list',
        basic: false,
        options: {
          1: {
            en: '1st Trial grounds target',
            zhHant: '第一個實證戰場目標',
            ja: '証明の戦域1行目',
            ko: '증명의 전장 1단계',
          },
          2: {
            en: '2nd Trial grounds target',
            zhHant: '第二個實證戰場目標',
            ja: '証明の戦域2行目',
            ko: '증명의 전장 2단계',
          },
          3: {
            en: '3rd Trial grounds target',
            zhHant: '第三個實證戰場目標',
            ja: '証明の戦域3行目',
            ko: '증명의 전장 3단계',
          },
          disabled: {
            en: 'disable auto trial grounds',
            zhHant: '不自動打實證戰場',
            ja: '証明の戦域自動戦闘しない',
            ko: '증명의 전장 자동 전투하지 않다',
          },
        },
        title: {
          en: 'Choose Trial grounds target (time jumper)',
          zhHant: '選擇實證戰場目標 (快轉發條)',
          ja: '証明の戦域を選択（早送りぜんまい使用）',
          ko: '증명의 전장을 선택(빨리감기 태엽장치 사용)',
        },
        help: {
          en: 'Auto clear selected trial grounds level with time jumper',
          zhHant: '實證戰場會自動用實間快轉發條打選定的關卡',
          ja: '早送りぜんまい使用による証明の戦域を自動戦闘する',
          ko: '빨리감기 태엽장치 사용에 의한 증명의 전장을 자동 전투하다',
        },
      },
      autoCollectMailIntervalInMins: {
        value: 120,
        hidden: false,
        suggestedMax: 360,
        suggestedMin: 120,
        type: 'number',
        title: {
          en: 'Auto collect mail interval (set to 0 to skip this task)',
          zhHant: '每隔幾分鐘自動收信 (設為0則不會進行此工作)',
          ja: 'ポストを自動受け取る／分間（数字）',
          ko: '몇 분 간격으로 선물함을 받을까요?',
        },
        help: {
          en: "Don't miss the gift from your friends!",
          zhHant: '不會錯過朋友送的禮物囉！',
          ja: '「0」を設定したら、動作されません。',
          ko: '친구가 보낸 선물을 놓칠 일이 없습니다.',
        },
      },
      autoCollectFountainIntervalInMins: {
        value: 40,
        hidden: false,
        suggestedMax: 300,
        suggestedMin: 40,
        type: 'number',
        title: {
          en: 'Auto claim fountain interval (set to 0 to skip this task)',
          zhHant: '每隔幾分鐘收自動噴泉 (設為0則不會進行此工作)',
          ja: '恵みの噴水を自動報酬GET /分間（数字）',
          ko: '몇 분 간격으로 풍요의 분수를 자동으로 받을까요?',
        },
        help: {
          en: 'Collect star jelly, hearts and other materials from the fountain every specified minutes',
          zhHant: '可以收到經驗糖、體力以及材料唷',
          ja: '「0」を設定したら、動作されません。',
          ko: '경험의 별사탕, 찬란한 빛조각, 설탕결정, 크리스탈, 스킬 파우더등을 얻을 수 있습니다.',
        },
      },
      autoCollectTropicalIslandsIntervalInMins: {
        value: 20,
        hidden: false,
        suggestedMax: 300,
        suggestedMin: 20,
        type: 'number',
        title: {
          en: 'Auto check tropical island interval (set to 0 to skip this task)',
          zhHant: '每隔幾分鐘檢查熱帶島嶼 (設為0則不會進行此工作)',
          ja: 'ソーダ諸島をチェック/分間ごと(0を設定したら、チェックされない)',
          ko: '몇 분 간격으로 트로피컬 소다 제도의 지역을 자동으로 확장시킬까요? (0으로 설정하면 진행하지 않습니다.)',
        },
        help: {
          en: 'Free sunbed cookies, clear re-occupied islands',
          zhHant: '解放日光浴餅乾，清理被佔領的島嶼',
          ja: '乾燥中のクッキーを復帰、海賊が占領された島に自動戦闘',
          ko: '자동으로 선베드의 쿠키를 복귀시키고 점령된 섬을 해방시킵니다.',
        },
      },
      autoHandleCollectCookieOdysseyMission: {
        value: false,
        hidden: false,
        type: 'boolean',
        title: {
          en: 'Auto collect cookie odyssey quills from daily finished missions',
          zhHant: '自動收餅乾奧德賽任務羽毛',
          ja: '自動でフェザーペンの保有数をチェックして受け取る',
          ko: '6시간마다 자동으로 쿠키 오디세이 미션에서 보상을 수령합니다.',
        },
        help: {
          en: 'Check if can collect odyssey quills every 6 hours',
          zhHant: '每六小時自動檢查一下有沒有羽毛要收',
          ja: '6時間毎にチェックする',
          ko: '6시간마다 수령할 보상이 있는지 확인합니다.',
        },
      },

      isTestAccount: {
        value: false,
        hidden: true,
        type: 'boolean',
        title: {
          en: 'When start, instead of start production right away, check if all daily tasks (guild battle, wanted, etc) had been fulfilled',
          zhHant: '進入遊戲不直接開始生產，先檢查公會、懸賞等每日工作是否完成',
          ja: 'When start, instead of start production right away, check if all daily tasks (guild battle, wanted, etc) had been fulfilled',
          ko: 'When start, instead of start production right away, check if all daily tasks (guild battle, wanted, etc) had been fulfilled',
        },
        help: {
          en: '',
          zhHant: '',
          ja: '',
          ko: '',
        },
        divider: 'hidden',
      },
      axeStockTo400: {
        value: false,
        hidden: true,
        type: 'boolean',
        title: {
          en: 'Stock axe to 400',
          zhHant: '存400個斧頭',
          ja: '硬い斧x400を生産する',
          ko: '단단한 도끼 400을 생산하기 (네/아니오)',
        },
        help: {
          en: 'For specific territory expension',
          zhHant: '擴張特殊領地用',
          ja: 'エリアを拡張するため',
          ko: '특수 영지 확장용입니다',
        },
      },

      sleepWhenDoubleLoginInMinutes: {
        value: 0,
        hidden: true,
        type: 'number',
        title: {
          en: 'Wait how many minutes to try login after being kicked by re-login',
          zhHant: '被踢掉後要等多少分鐘再重新登入',
          ja: '被踢掉後要等多少分鐘再重新登入',
          ko: '다른 기기에서 중복 로그인으로 인해 접속이 끊길경우, 몇 분 후에 다시 로그인할까요?',
        },
        help: {
          en: 'in minutes (default is 0)',
          zhHant: '以分鐘計算，預設是馬上重新登入遊戲',
          ja: '以分鐘計算，預設是馬上重新登入遊戲',
          ko: '설정한 시간이 지난후 자동으로 다시 로그인후 매크로를 이어 진행합니다.',
        },
      },
    };

    return {
      isLoading: false,
      defaultConfig: defaultConfig,
      localTaskConfig: cloneDeep(defaultConfig),
      showAdvancedConfig: false,
    };
  },
  created() {
    if (!this.license) {
      this.$router.push({ name: 'home' });
      return;
    }

    const config = this.license.taskConfig;
    if (!isEmpty(config) && Object.keys(config).length > 0) {
      for (const key in config) {
        if (key in this.localTaskConfig) {
          this.localTaskConfig[key].value = config[key];
        } else {
          // These are currently unchangeable setting so ignore them
        }
      }
    }
  },
  computed: {
    // Draw the UI to show if the given licence exist
    isLicenseFound() {
      if (isEmpty(this.license)) {
        return false;
      }
      return true;
    },
  },
  watch: {
    enableRecord(v) {
      if (v && this.newRecordId === '') {
        this.newRecordId = this.genRecordId();
      }
    },
  },
  methods: {
    isEmpty(x) {
      return isEmpty(x);
    },
    getErrorMessage(item) {
      let errorMessage = '';
      if (item.suggestedMin !== undefined && +item.value !== 0 && +item.value < item.suggestedMin) {
        errorMessage = `${item.value} ${this.$i18n.t('is_lower_than')} ${item.suggestedMin}`;
      } else if (item.suggestedMax !== undefined && +item.value > item.suggestedMax) {
        errorMessage = `${item.value} ${this.$i18n.t('is_higher_than')} ${item.suggestedMax}`;
      }
      return errorMessage;
    },
    back() {
      this.$router.push({ name: 'home' });
    },
    reset() {
      for (const key in this.defaultConfig) {
        if (key === 'account' || key === 'password') {
          continue;
        }
        this.localTaskConfig[key].value = this.defaultConfig[key].value;
      }
    },
    async save() {
      let configToPost = {};
      for (const key in this.localTaskConfig) {
        // check is number type
        if (typeof this.defaultConfig[key].value === 'number') {
          configToPost[key] = +this.localTaskConfig[key].value;
        } else {
          configToPost[key] = this.localTaskConfig[key].value;
        }
      }

      if (configToPost.account === '' || configToPost.password === '') {
        alert(this.$i18n.t('account_and_password_are_must'));
        return;
      }

      this.isLoading = true;
      if (configToPost.account.indexOf('@') !== -1) {
        if (!(await this.isDevPlayExist(configToPost.account))) {
          this.localTaskConfig.account.error = this.$i18n.t('account_not_exist');
          this.isLoading = false;
          alert(this.$i18n.t('account_not_exist'));
          return;
        }
      }

      await firebase.functions().httpsCallable('xPostTaskConfigs')({
        licenseId: this.license.licenseId,
        task: this.license.task || 'cookieKingdom',
        taskConfig: configToPost,
      });

      this.isLoading = false;
      this.$router.push({ name: 'home' });
    },
    genRecordId() {
      const licenseId = this.license.licenseId;
      const licensePrefix = licenseId.substr(0, 6);
      const datePrefix = moment().format('YYYYMMDD-HHmm'); // 12
      const randomPrefix = Math.random().toString(36).substr(2, 6);
      const recordId = `${randomPrefix}-${datePrefix}-${licensePrefix}`;
      return recordId;
    },
    onResetRecordIdClick() {
      this.newRecordId = this.genRecordId();
    },
    getFileIdFromDriveUrl(url) {
      // follow example all tested
      // 1UsVsL7y05cG_L_AlJXoT5d6c-ema2sUc
      // https://drive.google.com/folderview?id=1UsVsL7y05cG_L_AlJXoT5d6c-ema2sUc
      // https://drive.google.com/open?id=1UsVsL7y05cG_L_AlJXoT5d6c-ema2sUc
      // https://drive.google.com/drive/folders/1UsVsL7y05cG_L_AlJXoT5d6c-ema2sUc
      url = url + '/';
      const match = url.match(/([a-z0-9_-]{25,})[$/&?]/i);
      return match ? match[1] : '';
    },
    async isDevPlayExist(email) {
      try {
        const result = await firebase.functions().httpsCallable('xMiscAPI-isDevPlayExist')({
          email,
        });
        console.log('result');
        return result.data;
      } catch (e) {
        return true;
      }
    },
    optionsList(targetObject) {
      return Object.entries(targetObject.options).map(([key, value]) => {
        return { text: value[this.$i18n.locale], value: key };
      });
    },
  },
};
</script>
